import {useEffect} from 'react';
import {useScannerControls} from 'context/kiosko/hooks';
import {KioskoScanData} from 'context/kiosko';

type UseScanDocumentProps = {
  onDocumentScanned: (data: KioskoScanData | null) => void;
};
function useScanDocument({onDocumentScanned}: UseScanDocumentProps) {
  const {scanDocument, lastScanResult, success, resetScannerState} = useScannerControls();

  useEffect(
    function onDocumentScannedEffect() {
      if (Boolean(lastScanResult) && success) {
        onDocumentScanned(lastScanResult);
        resetScannerState();
      }
    },
    [lastScanResult, onDocumentScanned, resetScannerState, success],
  );

  return {
    scanDocument,
  };
}

export {useScanDocument};
